<!-- ROI Comparison Pie Charts using reusable component -->
<app-pie
  [tabName]="'Course Comparison'"
  [universitiesData]="transformedUniversities"
  [metrics]="availableMetrics"
  [chartSize]="[200, 200]"
  [showAnimations]="false"
  [colorScheme]="'vivid'"
  (pieChartSelect)="onPieChartSelect($event)">
</app-pie>

<!-- Enhanced Analysis Evidence and Recommendations -->
@if(evidenceSources.length > 0 || recommendations.length > 0){
<div class="enhanced-analysis-section">
  <!-- Evidence Sources -->
  @if(evidenceSources.length > 0){
  <div class="evidence-section">
    <h3 class="section-title">
      <mat-icon>source</mat-icon>
      Comparison Data Sources
    </h3>
    <div class="evidence-capsules">
      @for(evidence of evidenceSources; track evidence.url){
      <div class="evidence-capsule" 
           [matTooltip]="getEvidenceTooltip(evidence)" 
           matTooltipPosition="above"
           matTooltipClass="evidence-tooltip"
           (click)="openSourceLink(evidence.url)"
           [title]="'Click to view source: ' + evidence.url">
        {{ evidence.source }}
      </div>
      }
    </div>
  </div>
  }

  <!-- Recommendations -->
  <!-- @if(recommendations.length > 0){
  <div class="recommendations-section">
    <h3 class="section-title">
      <mat-icon>lightbulb</mat-icon>
      Performance Improvement Recommendations
    </h3>
    <div class="recommendations-grid">
      @for(rec of recommendations; track rec.category){
      <div class="recommendation-card" [class]="'priority-' + rec.priority.toLowerCase()">
        <div class="recommendation-header">
          <span class="recommendation-category">{{ rec.category }}</span>
          <span class="recommendation-priority" [class]="'priority-' + rec.priority.toLowerCase()">
            {{ rec.priority }}
          </span>
        </div>
        <div class="recommendation-content">
          <p class="recommendation-issue">{{ rec.issue }}</p>
          <p class="recommendation-text">{{ rec.recommendation }}</p>
          <div class="recommendation-impact">
            <mat-icon>trending_up</mat-icon>
            <span>{{ rec.expected_impact }}</span>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  } -->
</div>
}
